'use client';
import SingleSolution from '@/components/Solutions/singleSolution';

export default function SingleSolutionClient() {
  return <SingleSolution />;
}
